export default __webpack_public_path__ + "static/media/Heaven's Jang Gum.e91ed28a.jpg";